module.exports = __webpack_public_path__ + "img/logo-paloma-large.d1341254.png";